import { useMutation, useQueryClient } from '@tanstack/react-query';
import useApi from 'hooks/useApi';
import printingFactory from 'utils/factories/printing';

export default function useDeleteOrder() {
  const api = useApi();
  const queryClient = useQueryClient();

  const deleteOrder = useMutation({
    mutationKey: ['deleteOrder'],
    mutationFn: (id: string) => api.printingOrders.apiPrintingOrdersIdDelete(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: printingFactory.list() }),
  });

  return deleteOrder;
}
